'use strict';

function RegionEvent(csv_url, region_id) {
    this.url = csv_url;
    this.region_id = region_id;
    this.container = $('#region_event_container');
    this.DATASHEET = {};
    this.dataCount = 0;
    this.cover = null;
    this.title = null;
    this.content = null;
    this.swiper = [];
    this.classList = {
        'cover': '.event-cover .cover',
        'titleLoading': '.region-event__title-block h3.block-loading',
        'contentLoading': '.region-event__title-block p.dotdotdot.block-loading',
        'content': '.region-event__title-block p.dotdotdot:not(.block-loading)',
        'swiperContainer': '.c-slider-container'
    };
}

var EmptyEventBlock = '\n    <div class="region-block__wrapper">\n      <div class="c-slider-container swiper-container">\n        <div class="c-slider-header">\n          <div class="c-slider__btn-group">\n            <div class="c-slider__btn c-slider__btn--border prev"><i class="fa fa-long-arrow-left"></i></div>\n            <div class="c-slider__btn c-slider__btn--border next"><i class="fa fa-long-arrow-right"></i></div>\n          </div>\n          <div class="region-event__title-block">\n            <h3 class="block-loading"></h3>\n            <p class="dotdotdot block-loading" data-lines="3" data-blog=""></p>\n            <div class="event-cover visible-sm visible-xs">\n              <div class="cover block-loading" style="background-image:url(\'\')"></div>\n            </div>\n          </div>\n        </div>\n        <div class="c-slider-wrapper swiper-wrapper region-event">\n          <div class="swiper-slide event-cover hidden-sm hidden-xs">\n            <div class="cover block-loading" style="background-image:url(\'\')"></div>\n          </div>\n          <div class="swiper-slide card">\n            <a href="">\n              <div class="cover block-loading" style="background-image:url(\'\')"></div>\n              <div class="info-block">\n                <h4 class="blog-title block-loading"></h4>\n                <p class="blog-description block-loading"></p>\n                <p class="blog-description block-loading"></p>\n              </div>\n            </a>\n          </div>\n          <div class="swiper-slide card">\n            <a href="">\n              <div class="cover block-loading" style="background-image:url(\'https://dummyimage.com/360x210/c9c9c9/fff.png&text=Blog\')"></div>\n              <div class="info-block">\n                <h4 class="blog-title block-loading"></h4>\n                <p class="blog-description block-loading"></p>\n                <p class="blog-description block-loading"></p>\n              </div>\n            </a>\n          </div>\n        </div>\n      </div>\n    </div>';

/*
 * Google Sheet Fields
 * name, content, intro_blog_id, type, src, blog, rpg_id, ptid
 * 欄位說明:
 *   name           活動標題
 *   content        活動介紹
 *   intro_blog_id  活動介紹 blog id
 *   type           封面類型 image, video
 *   src            封面來源 圖片連結 or 嵌入影片來源
 *   blog           活動相關 blog id 等號分隔
 *   rpg_id         分類id, 搭配原本 region_id 下的分類商品
 *   ptid           商品id 以等號分隔
 */

RegionEvent.prototype.FetchRegionEvent = function (lines) {
    var self = this;
    var fields = [];
    var CHT_DATA = {},
        ENG_DATA = {},
        JAP_DATA = {};
    var Current = CHT_DATA;

    lines.forEach(function (v, i) {
        var rowData = v.match(/(".*?"|[^",\s]+)(?=\s*,|\s*$)/g);
        // 遇到空行,跳過
        if (rowData === null) {
            console.log('line(' + i + ') 沒資料');
        } else {
            // 第一行, 取出欄位
            if (i === 0) {
                fields = rowData;
                // 初始化三種語系資料
                rowData.forEach(function (v) {
                    CHT_DATA[v] = [];
                    ENG_DATA[v] = [];
                    JAP_DATA[v] = [];
                });
            } else {
                if (rowData[0] == 'English') {
                    // 切換目前要放入資料 refrence
                    Current = ENG_DATA;
                } else if (rowData[0] == '日文') {
                    // 切換目前要放入資料 refrence
                    Current = JAP_DATA;
                } else {
                    // 放入資料
                    rowData.forEach(function (v, j) {
                        Current[fields[j]].push(v);
                    });
                }
            }
        }
    });
    // 根據語言確認資料
    if (LANGUAGE === 'en-US') {
        self.DATASHEET = ENG_DATA;
    } else if (LANGUAGE === 'ja-JP') {
        self.DATASHEET = JAP_DATA;
    } else {
        self.DATASHEET = CHT_DATA;
    }
    self.dataCount = self.DATASHEET.name.length;
    return true;
};

RegionEvent.prototype.ReGenerateIFrame = function (src) {
    var ifrm = document.createElement('iframe');
    ifrm.setAttribute('src', src);
    ifrm.classList.add('embed-responsive-item');
    return ifrm;
};
// 主打活動內文 + [查看全文]
RegionEvent.prototype.ContentEllipsis = function () {
    var lines = $(this).data('lines');
    var height = parseInt($(this).css('line-height'), 10) * lines;
    var isTruncated = $(this).triggerHandler('isTruncated');
    var readmoreDom = '<a class="read-article">[' + i18n.t('View All') + ']</a>';

    if ($(this).height() > height && isTruncated !== false) {
        $(this).find('br').replaceWith('<span />');
        $(this).append(readmoreDom);

        $(this).dotdotdot({
            ellipsis: '...... ',
            wrap: 'letter',
            after: 'a.read-article',
            height: height,
            watch: 'true'
        });
    } else {
        if (isTruncated) {
            console.log('do nothing');
        } else {
            readmoreDom = '...... ' + readmoreDom;
            $(this).append(readmoreDom);
        }
    }
};

RegionEvent.prototype.SettingEventCover = function () {
    for (var i = 0, max = this.DATASHEET.name.length; i < max; i++) {
        // setting title, content, intro_blog_id
        var title = this.DATASHEET.name[i].replace(/\"/g, '');
        var content = this.DATASHEET.content[i].replace(/\"/g, '');
        $(this.title[i]).text(title).removeClass('block-loading');
        $(this.content[i]).text(content).removeClass('block-loading');
        $(this.content[i]).attr('data-blog', this.DATASHEET.intro_blog_id[i]);
        this.ContentEllipsis.call($(this.content[i]));

        if (this.DATASHEET.type[i].toLowerCase() === 'image') {
            console.log('replace Region Evnet image');
            FunNowTools.replaceLoadingBlock(this.cover[i * 2], this.DATASHEET.src[i]);
            FunNowTools.replaceLoadingBlock(this.cover[i * 2 + 1], this.DATASHEET.src[i]);
        } else if (this.DATASHEET.type[i].toLowerCase() === 'video') {
            console.log('replace Region Evnet video');
            var iframe = this.ReGenerateIFrame(this.DATASHEET.src[i]);
            $(this.cover[i * 2]).addClass('embed-responsive embed-responsive-16by9').append(iframe).removeClass('block-loading');
            $(iframe).clone().appendTo($(this.cover[i * 2 + 1]));

            $(this.cover[i * 2 + 1]).addClass('embed-responsive embed-responsive-16by9').removeClass('block-loading');
        }
        var sliders = this.container.find(this.classList.swiperContainer);

        this.swiper.push(FunNowTools.setSlider(sliders[i], 30, 1));
    }
};

RegionEvent.prototype.setBlogCard = function (data) {
    if (data.status === 'error') return false;

    var self = this;
    var article = data.article;
    var url = FunNowTools.prefixUrl + '/blog/' + article.id;
    var coverPath = article.cover_image == '' ? 'web/images/default.png' : article.cover_image;
    var blogCover = GLOBAL.CDN_URI + FunNowTools.getCover(coverPath);
    var createtime = article.create_time.split(' ')[0];
    var title = article.abstract;
    var subContent = FunNowTools.subContent(article.content, 100);
    var card = '\n    <a href="' + url + '" class="swiper-slide card card--event">\n      <div class="cover" style="background-image:url(\'' + blogCover + '\')"></div>\n      <div class="card__info">\n        <div class="blog-createtime">\n          <i class="icon icon-calendar"></i> ' + createtime + '\n        </div>\n        <h4 class="blog-title">' + title + '</h4>\n        <p class="blog-description">' + subContent + '</p>\n      </div>\n    </a>\n    ';
    console.log('append Blog Card');
    self.appendSlide(card);
};

RegionEvent.prototype.SettingBlog = function () {
    var _this = this;

    var _loop = function _loop(i) {
        if (_this.DATASHEET.blog[i] === 'null') {
            return 'continue';
        }
        blogs = _this.DATASHEET.blog[i].replace(/\"/g, '').split(',');

        blogs.forEach(function (id) {
            FunNowTools.getArticle(id, _this.setBlogCard, _this.swiper[i]);
        });
    };

    for (var i = 0; i < this.DATASHEET.name.length; i++) {
        var blogs;

        var _ret = _loop(i);

        if (_ret === 'continue') continue;
    }
};

RegionEvent.prototype.setProductCard = function (data) {
    if (data.status === 'error') return false;

    var self = this;
    var products = data.products;
    for (var i = 0, max = products.length; i < max; i++) {
        var product = products[i];
        var url = '/products/' + product.product_id;
        var coverPath = product.cover_image == '' ? 'web/images/default.png' : product.cover_image;
        var cover = GLOBAL.CDN_URI + FunNowTools.getCover(coverPath);
        var bName = product.branch_name;
        var pName = product.product_name;
        var area = product.area;
        var RSP = i18n.t('RSP') + ' ' + product.symbol_code + ' ' + FunNowTools.thousandComma(product.rrp);
        var Sell = product.symbol_code + ' ' + FunNowTools.thousandComma(product.discount);
        var card = '\n        <a href="' + url + '" class="swiper-slide card card--event">\n          <div class="cover" style="background-image:url(\'' + cover + '\')">\n          </div>\n          <div class="card__info">\n            <p class="card-info__area card-info__area--sm">' + area + '</p>\n            <h4 class="card-info__title">' + bName + '<br>' + pName + '</h4>\n            <div class="card-info__hori-block">\n              <span class="price"><del>' + RSP + '</del></span>\n              <span class="price price--sell">' + Sell + '</span>\n            </div>\n          </div>\n        </a>';
        console.log('append Product Card');
        self.appendSlide(card);
    }
};

RegionEvent.prototype.SettingProducts = function () {
    var _this2 = this;

    var _loop2 = function _loop2(i) {
        var api_url = '';
        if (_this2.DATASHEET.category_id[i] === 'null' && _this2.DATASHEET.ptid[i] === 'null') {
            return 'continue';
        } else if (_this2.DATASHEET.category_id[i] !== 'null') {
            var category_id = _this2.DATASHEET.category_id[i].replace(/\"/g, '').split(',')[0];
            api_url += '/products?region_id=' + _this2.region_id + '&category_id=' + category_id;
        } else if (_this2.DATASHEET.ptid[i] !== 'null') {
            var ptids = _this2.DATASHEET.ptid[i].replace(/\"/g, '');
            api_url += '/products?pids=' + ptids;
        }
        var self = _this2;
        if (api_url !== '') {
            $.get(api_url, function (data) {
                self.setProductCard.call(self.swiper[i], data);
            });
        }
    };

    for (var i = 0; i < this.DATASHEET.name.length; i++) {
        var _ret2 = _loop2(i);

        if (_ret2 === 'continue') continue;
    }
};

RegionEvent.prototype.AdjustEmptyEventBlock = function (length) {
    // 畫面預設一個空區塊
    var count = length - 1;
    if (count < 0) {
        this.container.remove();
    } else if (count > 0) {
        while (count-- > 0) {
            this.container.append(EmptyEventBlock);
        }
    }
    // 重新計算封面數, 標題, 描述
    this.cover = $(this.classList.cover);
    this.title = $(this.classList.titleLoading);
    this.content = $(this.classList.contentLoading);
};

RegionEvent.prototype.RemoveFakeBlock = function () {
    var self = this;
    this.swiper.forEach(function (v, index) {
        var slides = v.slides;
        if (slides !== undefined) {
            for (var i = slides.length - 1; i >= 0; i--) {
                if (slides[i].classList.contains('fake-card')) {
                    self.swiper[index].removeSlide(i);
                }
            }
        }
    });
};

RegionEvent.prototype.LoadDataSheet = function () {
    var self = this;
    $.ajax({
        type: 'GET',
        xhrFields: {
            withCredentials: false
        },
        url: this.url,
        success: function success(response) {
            var lines = response.split(/\r?\n/);
            self.FetchRegionEvent(lines);
            console.log(self.DATASHEET);
            self.AdjustEmptyEventBlock(self.dataCount);
            // 設定標題、介紹、封面
            self.SettingEventCover();
            // 設定文章,商品
            self.SettingBlog();
            self.SettingProducts();
            self.RemoveFakeBlock();
        },
        error: function error(_error) {
            console.log('load google sheet fail');
            console.error(_error);
            self.container.remove();
        }
    });
};

// [地區頁] 主打活動點擊 [查看全文]
$(document).on('click', '.dotdotdot a.read-article', function (e) {
    e.preventDefault();
    var blog_id = $(this).parents('.dotdotdot').data('blog');
    var blog_url = FunNowTools.prefixUrl;

    blog_url += '/blog/' + blog_id;
    window.open(blog_url);
});